import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track3ABlue = ({ state, workState, onLabelClick }) => (
	<g id="Track3ABlue" transform="translate(694.498047, 637.000000)" className="track">
		<g id="line"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<g transform="translate(-2, 0)">
				<path
					d="M434.319757,34.1738281 L430.17402,31.9549159 C419.055635,26.0040513 405.782006,25.6448294 394.358037,30.9856342 L394.017416,31.1448774 L394.017416,31.1448774"
					strokeWidth={tracksWidth} strokeLinecap="round"
				/>
			</g>

			<path
				d="M244.978027,12 L165.870439,22.8502541 C162.040305,23.3755884 159.361235,26.9063932 159.886569,30.7365273 C159.978494,31.4067343 160.167083,32.0600772 160.446456,32.6761767 L165.599763,44.0407489 C167.551936,48.3458684 165.644495,53.4184059 161.339376,55.3705784 C159.165844,56.3561744 156.679516,56.3895309 154.480326,55.4625991 L132.302325,46.1148424 C122.143165,41.8328807 110.436324,46.5972909 106.154362,56.7564505 C104.581068,60.4891655 104.180598,64.6121929 105.006144,68.5779072 L108.374069,84.7565842 C110.994378,97.343901 105.302462,110.201483 94.2225025,116.723835 L71.228774,130.259371 C51.0624278,142.130534 34.4743097,159.22499 23.2146808,179.739053 L-2.84217094e-14,222.03418 L-2.84217094e-14,222.03418"
				strokeWidth={tracksWidth} strokeLinecap="round"/>
			<path
				d="M385.555117,35.1010757 L376.25879,39.4471889 C373.757242,40.6166842 370.781274,39.5368422 369.611779,37.0352944 C369.240926,36.2420419 369.084903,35.3653051 369.15932,34.4928127 L370.119128,23.2397745 C370.447678,19.3877674 367.591351,15.9987564 363.739344,15.6702064 C362.574691,15.5708695 361.403703,15.7647603 360.333226,16.2341874 L338.434882,25.8370767 C335.451927,27.1451661 331.973347,25.7874189 330.665258,22.8044633 C329.844426,20.9326457 330.051266,18.769282 331.211914,17.0869141 C334.215888,12.7326322 333.121248,6.76758697 328.766966,3.76361275 C326.89155,2.46978271 324.616342,1.88685253 322.349833,2.11948136 L255.245114,9.00694144 L255.245114,9.00694144"
				strokeWidth={tracksWidth} strokeLinecap="round"/>
		</g>

		<TrackArrow
			transform="translate(395.064810, 30.256678) rotate(-381.000000) translate(-396.064810, -30.256678)"
			points="400.06481 38.2566779 392.06481 30.2566779 400.06481 22.2566779"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<TrackArrow
			transform="translate(257.190621, 8.882096) rotate(-367.000000) translate(-257.190621, -8.882096)"
			points="261.190621 16.8820957 253.190621 8.88209568 261.190621 0.882095679"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track3ABlue')}
			coords="65.527338, 103.781670"
			text="3A"
			textCoordsX="10.3208008"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track3ABlue.propTypes = trackPropTypes;

export default Track3ABlue;
